import { DE_MINIMIS_TITLE } from '@/utils/constants';

import { documentFormMixin } from './documentForm';

// @vuese
// OW-004 Mixin
export const ow004Mixin = {
  data() {
    return {
      deMinimisConstant: DE_MINIMIS_TITLE
    };
  },
  mixins: [documentFormMixin],
  computed: {
    // Metoda zwracająca typ zawodu
    typeOfProfesion() {
      return this.dictionary.profesion;
    },

    // Metoda zwracająca tytuł tla panelu de minimis
    deMinimisTitle() {
      const defaultDeMinimis = 'IV. Oświadczenie o otrzymanej pomocy de minimis';
      if (this.data.deMinimis.isDeMinimis === null) {
        return defaultDeMinimis;
      }
      const selectedDeMinimis = this.deMinimisConstant.find(x => x.value === this.data.deMinimis.isDeMinimis);
      return (selectedDeMinimis && selectedDeMinimis.text) || defaultDeMinimis;
    },

    // Zwraca wartości ze słownika
    getDeMinimisApplicant() {
      return this.dictionary.deMinimisApplicant;
    },

    // Zwraca rodzaj przedsiębiorcy
    companyType() {
      return this.dictionary.company;
    }
  },

  methods: {
    // Sprawdza czy w danym obiekcie, jego podobiekty zawierają wartość true
    isTrue(model) {
      return Object.values(model).some(x => x === true);
    }
  }
};
